// This function allow to reference chunks
__webpack_require__.miniCssF = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "css/" + chunkId + "-" + {"337": "87fb5276","381": "ef46db37","696": "f7f99592",}[chunkId] + ".css"
}